namespace RioERP.Orders {
    export interface RazorPaySettingsRow {
        Id?: number;
        KeyId?: string;
        KeySecret?: string;
        WebhookSecret?: string;
        WebhookUrl?: string;
        RedirectUrl?: string;
        IsActive?: number;
        InsertUserId?: number;
        InsertDate?: string;
        UpdateUserId?: number;
        UpdateDate?: string;
    }

    export namespace RazorPaySettingsRow {
        export const idProperty = 'Id';
        export const nameProperty = 'KeyId';
        export const localTextPrefix = 'Orders.RazorPaySettings';
        export const lookupKey = 'Orders.RazorPaySettings';

        export function getLookup(): Q.Lookup<RazorPaySettingsRow> {
            return Q.getLookup<RazorPaySettingsRow>('Orders.RazorPaySettings');
        }
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            Id = "Id",
            KeyId = "KeyId",
            KeySecret = "KeySecret",
            WebhookSecret = "WebhookSecret",
            WebhookUrl = "WebhookUrl",
            RedirectUrl = "RedirectUrl",
            IsActive = "IsActive",
            InsertUserId = "InsertUserId",
            InsertDate = "InsertDate",
            UpdateUserId = "UpdateUserId",
            UpdateDate = "UpdateDate"
        }
    }
}
